import { createApiInstance } from './handler';

const healthTest = () => createApiInstance().get('/public/health');

export default healthTest;
